// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"84":"3c93f6c8","653":"88697f9e"}[chunkId] + ".css";
};